import { BannerTiny } from 'components/banner-tiny/banner-tiny';
import { useTranslation } from 'react-i18next';

import { PackageOutline } from '@olist/design-system-icons';

import { InvalidSegmentCard, InvalidSegmentContent } from './segment-dropdown.style';

const InvalidSegmentAlert = () => {
  const { t } = useTranslation();

  return (
    <InvalidSegmentCard>
      <div>
        <PackageOutline color="#0C29D0" width={24} height={24} />
      </div>
      <InvalidSegmentContent>
        <h3>{t`category not accepted on Olist`}</h3>
        <p>
          {t`Unfortunately, it is not possible to sell products in your category with Olist Store. If you work with other segments, review the list of options to continue your registration.`}
        </p>
        <p>
          {t`Otherwise, we recommend that you advertise your products on marketplaces using Tiny, which is part of the Olist Group.`}
        </p>

        <p>{t`Tiny is a management system with integration hub capabilities. With it, you can:`}</p>

        <ul>
          <li>
            {t`Advertise products on dozens of marketplaces, such as Mercado Livre, Shopee, Amazon, Americanas and Aliexpress`}
          </li>
          <li>{t`Control products, stock, prices and orders in a few clicks`}</li>
          <li>{t`Issue invoices automatically`}</li>
          <li>{t`Reduce operational errors and gain efficiency`}</li>
        </ul>
        <BannerTiny />
      </InvalidSegmentContent>
    </InvalidSegmentCard>
  );
};

export default InvalidSegmentAlert;
